// extracted by mini-css-extract-plugin
export var editButton = "_p6-0";